import _ from 'lodash'
import {PaymentMethodsEnum} from "../enums/PaymentMethodsEnum"

export default  function checkIfBankBilletIsEnabled(getSystemConfig){

    return async function() {
        const paymentMethodsResult = await getSystemConfig('PARAM_PAYMENT_METHODS')
        const paymentMethods = _.get(paymentMethodsResult, 'parameterValue' , '')


        return paymentMethods.split('|').indexOf(PaymentMethodsEnum.BANK_BILLET.code + '') >= 0
    }



}


// WEBPACK FOOTER //
// ./src/_functions/checkIfBankBilletEnabled.js